import { useMesfRealtime } from "@dexteel/mesf-core";

/**
 * SP names (realtime topics) that should trigger a data refresh on the CAS Data Entry page.
 *
 * Current triggers:
 *   Caster Mold set online/offline -> RBD.EQPCasterSetOnline / EQPCasterSetOffline -> CAS.DEGetProcess
 */
const REFRESH_TOPICS = ["CAS.DEGetProcess"];

/**
 * Subscribes to the realtime topics above and triggers a data refresh on the CAS Data Entry page.
 *
 * The page loads its data through context (not React Query), so it can't use
 * `meta: { realtime }` on a query; it keeps an explicit subscription instead.
 * Once the page moves to React Query, put the topics on the query's meta and delete this hook.
 *
 * @param onRefresh - Callback invoked when a relevant topic is invalidated.
 *                    Typically calls `refreshData()`. useMesfRealtime always calls
 *                    the latest callback, so no ref is needed.
 */
export const useRealtimeRefresh = (onRefresh: () => void) => {
  useMesfRealtime({
    topics: REFRESH_TOPICS,
    onMessage: () => onRefresh(),
  });
};
